<div class="profile__wrapper">
  <form [formGroup]="bcoinData" class="bcoin__form" autocomplete="off">
    <i
      class="icon-pencil"
      [class.grey]="isEditable"
      (click)="switchEdit($event)"
    ></i>
    <fieldset [disabled]="!isEditable" class="form__fieldset">
      <div class="form__row row">
        <div class="form__col col-sm-6">
          <div class="form__item row">
            <label
              class="label-input col-sm-3"
              appMarkAsterisk
              [formGroup]="bcoinData"
              [controlName]="'total'"
              [touched]="total.touched"
              >General balance</label
            >
            <div class="input__wrapper col-sm-6">
              <input
                type="number"
                class="input__basic"
                placeholder=" "
                formControlName="total"
              />
              <app-error-field
                [displayError]="total!.hasError('required')"
                [errorMessage]="'The field is required'"
              ></app-error-field>
              <app-error-field
                [displayError]="
                  total!.hasError('min') && !bcoinData.hasError('isNotValid')
                "
                [errorMessage]="'The value should be positive'"
              ></app-error-field>
              <app-error-field
                [displayError]="
                  !total!.hasError('required') &&
                  bcoinData.hasError('isNotValid')
                "
                [errorMessage]="'Total amount should be greater than Spent'"
              ></app-error-field>
            </div>
          </div>
          <div class="form__item row">
            <label
              class="label-input col-sm-3"
              appMarkAsterisk
              [formGroup]="bcoinData"
              [controlName]="'spent'"
              [touched]="spent.touched"
              >Spent B-coins</label
            >
            <div class="input__wrapper col-sm-6">
              <input
                type="number"
                class="input__basic"
                placeholder=" "
                formControlName="spent"
              />
              <app-error-field
                [displayError]="spent!.hasError('required')"
                [errorMessage]="'The field is required'"
              ></app-error-field>
              <app-error-field
                [displayError]="
                  spent!.hasError('min') && !bcoinData.hasError('isNotValid')
                "
                [errorMessage]="'The value should be positive'"
              ></app-error-field>
              <app-error-field
                [displayError]="
                  !spent!.hasError('required') &&
                  bcoinData.hasError('isNotValid')
                "
                [errorMessage]="'Spent amount should be less than Total'"
              >
              </app-error-field>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
  <button
    class="button button__save profile__button"
    *ngIf="isEditable"
    (click)="save()"
    #saveButton
  >
    Save
  </button>
</div>
